import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = ["id"];
import { computed, useId, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";
import { Button, Modal } from "@eudonet/opal";
import UserRolesEditor from "./UserRolesEditor.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserPermissionsModal',
    props: {
        modelValue: { type: Boolean },
        userId: {},
        roles: {},
        assignedRoles: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const titleId = useId();
        const editor = useTemplateRef("editor");
        // ×, Escape and the backdrop ask before discarding pending changes; Cancel discards on purpose.
        // None of them closes while a save runs: the editor holds the inline error and the retry.
        const isOpen = computed({
            get: () => props.modelValue,
            set: (value) => {
                if (!value)
                    void requestClose();
            },
        });
        async function requestClose() {
            if (editor.value?.isSaving)
                return;
            if (editor.value && !(await editor.value.requestClose()))
                return;
            close();
        }
        function close() {
            emit("update:modelValue", false);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Modal), {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((isOpen).value = $event)),
                size: "lg",
                "header-position": "left",
                "footer-position": "split",
                "aria-labelledby": _unref(titleId),
                "data-testid": "user-permissions-modal"
            }, {
                header: _withCtx(() => [
                    _createElementVNode("h3", {
                        id: _unref(titleId),
                        class: "text-(length:--size-l) font-(--weight-medium) leading-(--line-height-xxl) text-(--colors-text-heading) dark:text-(--colors-text-white-default)"
                    }, _toDisplayString(_unref(t)("accessManager.userDetail.permissions.title")), 9 /* TEXT, PROPS */, _hoisted_1)
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(Button), {
                        variant: "secondary",
                        label: _unref(t)('accessManager.userDetail.roles.cancel'),
                        disabled: editor.value?.isSaving,
                        "data-testid": "user-permissions-modal-cancel",
                        onClick: close
                    }, null, 8 /* PROPS */, ["label", "disabled"]),
                    (editor.value?.isEditable)
                        ? (_openBlock(), _createBlock(_unref(Button), {
                            key: 0,
                            variant: "primary",
                            label: _unref(t)('accessManager.userDetail.roles.save'),
                            disabled: !editor.value.canSave,
                            loading: editor.value.isSaving,
                            "data-testid": "user-permissions-modal-save",
                            onClick: _cache[0] || (_cache[0] = ($event) => (editor.value.save()))
                        }, null, 8 /* PROPS */, ["label", "disabled", "loading"]))
                        : _createCommentVNode("v-if", true)
                ]),
                default: _withCtx(() => [
                    _createVNode(UserRolesEditor, {
                        ref_key: "editor",
                        ref: editor,
                        "user-id": __props.userId,
                        roles: __props.roles,
                        "assigned-roles": __props.assignedRoles,
                        onSaved: close
                    }, null, 8 /* PROPS */, ["user-id", "roles", "assigned-roles"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "aria-labelledby"]));
        };
    }
});
